var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MobileServiceOverview',_vm._b({staticClass:"education-view",attrs:{"hero-image":_vm.educationHeroImage}},'MobileServiceOverview',_vm.educationOverview,false))
}
var staticRenderFns = []

export { render, staticRenderFns }